__turbopack_context__.v({
  "header": "sport-games-module-sass-module__7A3J6W__header",
  "sportGames": "sport-games-module-sass-module__7A3J6W__sportGames",
  "sportGamesCarousel": "sport-games-module-sass-module__7A3J6W__sportGamesCarousel",
});
